<template>
  <div id="userIndexView">
    <!--    <a-layout style="height: 400px">-->
    <!--      <a-layout-header>Header</a-layout-header>-->
    <!--      <a-layout-content>Content</a-layout-content>-->
    <!--      <a-layout-footer>Footer</a-layout-footer>-->
    <!--    </a-layout>-->
    <a-avatar>
      <img
        alt="avatar"
        src="https://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/3ee5f13fb09879ecb5185e440cef6eb9.png~tplv-uwbnlip3yd-webp.webp"
      />
    </a-avatar>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
#userIndexView {
}
</style>
